"use client";

import { useEffect, useState } from "react";
import { buscarJsonComCache } from "@/lib/fetch-cache-cliente";

const NOME_USUARIO_ATUALIZADO = "bp:nome-usuario-atualizado";

export function atualizarNomeUsuarioExibido(nome: string) {
  window.dispatchEvent(new CustomEvent(NOME_USUARIO_ATUALIZADO, { detail: nome }));
}

function useNomeUsuario() {
  const [nome, setNome] = useState<string | null>(null);

  useEffect(() => {
    let ativo = true;
    let atualizado = false;
    const aoAtualizar = (evento: Event) => {
      atualizado = true;
      setNome((evento as CustomEvent<string>).detail);
    };
    window.addEventListener(NOME_USUARIO_ATUALIZADO, aoAtualizar);
    buscarJsonComCache<{ nome?: string }>("/api/me", { ttl: 120_000 })
      .then((dados) => {
        if (ativo && !atualizado) setNome(dados.nome ?? null);
      })
      .catch(() => {});
    return () => {
      ativo = false;
      window.removeEventListener(NOME_USUARIO_ATUALIZADO, aoAtualizar);
    };
  }, []);

  return nome;
}

export function NomeUsuario({ primeiroNome = false }: { primeiroNome?: boolean }) {
  const nome = useNomeUsuario();
  if (!nome) return null;

  const nomeExibido = primeiroNome ? nome.trim().split(/\s+/)[0] ?? nome : nome;
  return <span>{nomeExibido}</span>;
}

export function NomeUsuarioComPonto() {
  const nome = useNomeUsuario();
  if (!nome) return null;

  return <span>{nome.trim().split(/\s+/)[0] ?? nome}</span>;
}
